import * as React from 'react';
import { graphql } from 'react-apollo';

import gql from 'graphql-tag';

import { Box, StyleSheet, css, fontFamily } from '@coursera/coursera-ui';

import { Spacer } from 'bundles/enterprise-ui/components';
import type {
  AutoEnrollmentQuery,
  AutoEnrollmentQueryVariables,
  AutoEnrollmentQuery_EnterpriseProgramsV1Resource_byThirdPartyOrganizationId_elements as EnterprisePrograms,
} from 'bundles/internal-enterprise/components/InternalThirdPartyOrganizationPage/__generated__/AutoEnrollmentQuery';
import DropdownMenu from 'bundles/internal-ui/components/forms/DropdownMenu';

import _t from 'i18n!nls/internal-enterprise';

import AutoEnrollmentSettingsBody from './AutoEnrollmentSettingsBody';

const styles = StyleSheet.create({
  dropdownLabel: {
    marginRight: '2em',
    marginLeft: '1em',
    fontFamily: fontFamily.bold,
  },
});
type State = {
  program?: { id: string; name: string };
};

type PropsFromCaller = {
  thirdPartyOrganizationId?: string;
};

type PropsFromGraphql = {
  programs: EnterprisePrograms[];
  loading?: boolean;
};

type Props = PropsFromCaller & PropsFromGraphql;

export type DropDownOption = {
  label: string;
  value: string;
};

export class AutoEnrollmentSettings extends React.Component<Props, State> {
  state = {} as State;

  getProgramDropdownOptions = () => {
    const options: DropDownOption[] = [{ value: '', label: _t('Select a program') }];
    const { programs } = this.props;

    programs.forEach((program) => {
      options.push({ label: program?.metadata?.name, value: program?.id });
    });

    return options;
  };

  updateProgram = (programId: $TSFixMe) => {
    const { programs } = this.props;
    const program = programs.filter((p) => p?.id === programId)[0];
    this.setState({ program: { id: programId ?? '', name: program?.metadata?.name ?? '' } });
  };

  render() {
    const { program } = this.state;

    return (
      <div data-testid="auto-enrollment-settings">
        <Box flexDirection="row" alignItems="center">
          <div {...css(styles.dropdownLabel)}>{_t('Program: ')}</div>
          <DropdownMenu
            onChange={(event) => {
              this.updateProgram(event.target.value);
            }}
            options={this.getProgramDropdownOptions()}
          />
        </Box>
        <Spacer size={32} />
        {program?.id && <AutoEnrollmentSettingsBody program={program} />}
      </div>
    );
  }
}

export default graphql<PropsFromCaller, AutoEnrollmentQuery, AutoEnrollmentQueryVariables, PropsFromGraphql>(
  gql`
    query AutoEnrollmentQuery($id: String!) {
      EnterpriseProgramsV1Resource {
        byThirdPartyOrganizationId(thirdPartyOrganizationId: $id) {
          elements {
            id
            metadata {
              name
            }
          }
        }
      }
    }
  `,
  {
    options: (props) => ({
      variables: { id: props.thirdPartyOrganizationId! },
    }),
    props: ({ data }) => {
      const elements = data?.EnterpriseProgramsV1Resource?.byThirdPartyOrganizationId?.elements || [];
      const programs = elements.filter((el) => !!el) as EnterprisePrograms[];

      return {
        programs,
      };
    },
  }
)(AutoEnrollmentSettings);
